import { Navigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

/** @param {{ allow: (user: { roles?: string[] } | null) => boolean, children: React.ReactNode }} props */
export function RoleRoute({ allow, children }) {
  const { user } = useAuth()
  if (!allow(user)) {
    return <Navigate to="/" replace />
  }
  return children
}
